/**
 *  All api related to attachment
 */
import _ from 'lodash'
import axios from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function createAttachment(attachment = {}) {
  const payload = {
    data: {
      attachment
    },
  }
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  cancelRequest.add(
    'createAttachment',
    () => source.cancel('createAttachment: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'attachments',
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      attachment: data.attachment
    }))
}

export function updateAttachment(id) {
  const payload = {
    data: {
      attachment:{
        state_events: [
          "finish_upload"
        ]
      }
    },
  }

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source()
  cancelRequest.add(
    'fecthUpdateAttachment',
    () => source.cancel('fecthUpdateAttachment: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `attachments/${id}`,
      method: 'put',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      attachment: data.attachment
    }))
}


export function createS3DirectUploadImage(responseAttachment, file) {
  const url = _.get(responseAttachment, 'directUploadData.uploadUrl')
  const params = _.get(responseAttachment, 'directUploadData.params')
  const formData = new FormData()

  formData.append('policy', params.policy)
  formData.append('x-amz-signature',params.xAmzSignature)
  formData.append('acl', params.acl)
  formData.append('x-amz-algorithm', params.xAmzAlgorithm)
  formData.append('x-amz-credential', params.xAmzCredential)
  formData.append('x-amz-date', params.xAmzDate)
  formData.append('key', params.key)
  formData.append('content-type', params.contentType)
  formData.append(_.get(responseAttachment, 'directUploadData.fileFieldName'), file)

  return axios({
      method: 'post',
      url: url,
      data: formData,
      headers: {'Content-Type': 'multipart/form-data' }
    })
    .then(response => {
      return response
    })
    .catch(error => {
      throw error
    })
}



